import { Head, Link } from "@inertiajs/react"

import AppLogo from "@/components/app-logo"
import AppLogoIcon from "@/components/app-logo-icon"
import { Button } from "@/components/ui/button"

interface Props {
  email_address: string
}

export default function EmailSuppressed({ email_address }: Props) {
  return (
    <>
      <Head title="Email undeliverable" />

      <div className="vignette noise bg-bg-body flex min-h-screen items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <Link href="/" className="inline-flex items-center justify-center">
              <AppLogo />
            </Link>
          </div>

          <div className="border-border bg-bg-card rounded-lg border p-8 shadow-lg">
            <h1 className="font-display mb-2 text-center text-2xl tracking-wide">
              YOUR INBOX ISN&apos;T ANSWERING
            </h1>

            <p className="text-bone-muted mb-4 text-center text-sm">
              We can&apos;t reach{" "}
              <strong className="text-bone">{email_address}</strong>.
            </p>

            <p className="text-bone-muted mb-6 text-center text-sm">
              Previous emails bounced or got marked as spam. Your inbox ghosted
              us, basically. We need to sort this out before you can sign in.
            </p>

            <Button asChild className="w-full">
              <a href="mailto:lifeline@todoordie.com?subject=Email%20delivery%20issue">
                Get help at lifeline@todoordie.com
              </a>
            </Button>

            <div className="mt-4 text-center">
              <Link
                href="/session/new"
                className="text-bone-muted hover:text-bone text-sm transition-colors"
              >
                Try a different email
              </Link>
            </div>

            <p className="text-bone-dim mt-6 text-center text-xs">
              We&apos;ll get you back in. Nobody gets left for dead.
            </p>
          </div>

          <div className="text-bone-dim mt-8 flex items-center justify-center gap-2 text-sm">
            <AppLogoIcon className="text-red h-5 w-5" />
            ToDoOrDie
          </div>
        </div>
      </div>
    </>
  )
}
